<template>
    <div>
        <div class="row">
      <div class="col-md-12">
        <div class="widget">
          <div class="form-elements-sec">
            <div class="widget-title">
              <h3>Üniversite Ekle</h3>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <label for="logo">Logo</label>
                  <input type="file" @change="onLogo" class="form-control custom-input">
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label for="city">Şehir</label>
                  <select class="form-control custom-input" v-model="city">
                        <option value selected hidden disabled>Seçiniz...</option>
                        <option v-for="city in cities" :key="city.id" :value="city.id">{{ city.name }}</option>
                  </select>
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group">
                  <label for="name">Üniversite Adı</label>
                  <input
                    type="text"
                    v-model="name"
                    class="form-control custom-input"
                    placeholder
                  >
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group">
                  <label for="lat">Enlem <small>(x)</small> </label>
                  <input
                    type="text"
                    v-model="lat"
                    class="form-control custom-input"
                    placeholder
                  >
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group">
                  <label for="lng">Boylam <small>(y)</small></label>
                  <input type="text" v-model="lng" class="form-control custom-input" placeholder>
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group">
                  <label for="address">Adres</label>
                  <input type="text" v-model="address" class="form-control custom-input" placeholder>
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group">
                  <label for="website">Website</label>
                  <input type="text" v-model="website" class="form-control custom-input" placeholder>
                </div>
              </div>

              <div class="col-md-12">
                <div class="form-group">
                  <label for="content">İçerik</label>
                  <vue-editor :editorToolbar="customToolbar" v-model="content" class="editor"></vue-editor>
                </div>
              </div>

              <div class="col-md-12">
                <div class="form-group">
                  <label for></label>
                  <button class="btn btn-success pull-right" @click="addData">Kaydet</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    </div>
</template>

<script>
    import { VueEditor } from "vue2-editor";
    export default {
        components: { VueEditor },
        data() {
            return {
                customToolbar: [
                  ['bold', 'italic', 'underline'],
                  [{ 'list': 'ordered'}, { 'list': 'bullet' }]
                ],
                api: 'universities/',
                city: '',
                cities: [],
                logo: null,
                name: null,
                lat: null,
                lng: null,
                address: null,
                website: null,
                content: null,
            }
        },
        methods: {
            onLogo(event) {
                this.logo = event.target.files[0]
                // console.log(this.logo)
            },
            getCities() {
                this.axios.get(this.api + 'create')
                    .then(response => {
                        this.cities = response.data
                    })
            },
            addData() {
                let data = {
                    city: this.city || '',
                    name: this.name || '',
                    lat: this.lat || '',
                    lng: this.lng || '',
                    address: this.address || '',
                    website: this.website || '',
                    content: this.content || '',
                }
                const formData = new FormData()
                if(this.logo) {
                  formData.append('logo', this.logo, this.logo.name)
                }
                Object.keys(data).map(e => {
                    formData.append(e, data[e])
                })
                this.$Progress.start()
                this.axios.post(this.api, formData)
                    .then(response => {
                        if(response.status == 201){
                            this.$router.push({ name: 'universities.update', params: {id: response.data.id}})
                        }
                    })
            }
        },
        mounted() {
            this.getCities()
        }
    }
</script>

<style scoped>

</style>
